import React, { useState } from "react"
import graphql from "babel-plugin-relay/macro"
import { Flex, Box } from "theme-ui"
import _ from "lodash"
import { ChromePicker } from "react-color"

import WebchatPreview from "../../components/WebchatPreview/WebchatPreview"
import NewBoxButton from "../../components/Radiate/NewBoxButton/NewBoxButton"
import CodeEditor from "../../components/Radiate/CodeEditor/CodeEditor"

import {
  useMutation
} from "react-relay"

import * as Styles from "./PreferencesStyles"

const decimalToHex = (alpha) => alpha === 0 ? '00' : Math.round(255 * alpha).toString(16)

const PreferencesMutation = graphql`
  mutation Preferences_updateBusinessMutation ($input: UpdateBusinessInput!) {
    updateBusiness(input: $input) {
      business {
        id
        businessId
        profile {
          name
          legalName
          about
          phones {
            number
            alias
          }
          addresses {
            line1
            line2
            city
            state
            country
            alias
          }
          websites {
            url
            alias
          }
          emails {
            email
            alias
          }
          logoUrl
          botAgentImageUrl
        }
        chatConfiguration {
          themeColor
          customCss
          showAgentProfile
          localised {
            localeId
            persistentMenu {
              buttons
              enable
            }
            iceBreakers {
              ctas
              enable
            }
            inputPlaceholder
          }
        }
      }
    }
  }
`

const Preferences = ({
  info,
}) => {
  const [businessInfo, setBusinessInfo] = useState(info)
  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false)
  const [cssString, setCssString] = useState(info?.chatConfiguration?.customCss || "")
  const defaultColors = ["#ff0000", "#ff9900", "#0014ff", "#412daf", "#1b6d3c"]

  const [commit, isInFlight] = useMutation(
    PreferencesMutation
  )
  const renderColorOptions = (options) => {
    const themeColor  = businessInfo?.chatConfiguration?.themeColor
    const colorOptions = options.map((o) => {
      return (
        <Styles.ColorDisplayBorder
          color={o}
          onClick={() => {
            const clone = _.cloneDeep(businessInfo)
            clone.chatConfiguration.themeColor = o
            setBusinessInfo(clone)
          }}
          selected={
            themeColor === o
          }
        >
          <Styles.ColorDisplay
            color={o}
          />
        </Styles.ColorDisplayBorder>
      )
    })

    return colorOptions
  }

  return (
    <Flex>
      <Box pr={4} sx={{ flexGrow: 1, height: "608px", width: "calc(100% - 440px)", minWidth: "500px" }}>
        <Flex py={3} sx={{ justifyContent: "flex-end" }}>
          <NewBoxButton
            text="Save"
            loading={isInFlight}
            primary
            disabled={_.isEqual(businessInfo, info)}
            onClick={() => {
              commit({
                variables: {
                  input: {
                    businessId: info?.businessId,
                    showAgentProfile: businessInfo?.chatConfiguration?.showAgentProfile,
                    customCss: businessInfo?.chatConfiguration?.customCss,
                    themeColor: businessInfo?.chatConfiguration?.themeColor,
                  },
                },
                onCompleted: (response, errs) => {},
                onError: (err) => {
                  console.log(err)
                }
              })
            }}
          />
        </Flex>
        <Flex pb={4} sx={{ alignItems: "center" }}>
          <Styles.Label noPadding>
            <div className="title">Show Agent Profile</div>
          </Styles.Label>
          <Styles.SToggle
            value={businessInfo?.chatConfiguration?.showAgentProfile}
            onChange={(value) => {
              const clone = _.cloneDeep(businessInfo)
              clone.chatConfiguration.showAgentProfile = value
              setBusinessInfo(clone)
            }}
          />
        </Flex>
        <Box pb={3}>
          <Styles.Label>
            <div className="title">Theme Color</div>
            <div className="text">Select the theme color you want to display on your chatbot</div>
          </Styles.Label>
          <Styles.ColorPicker className="color-picker info-content-wrapper">
            {renderColorOptions(defaultColors)}
            <Styles.StyledPopperContainer
              show={isColorPickerOpen}
              placement="bottom-start"
              positionFixed
              hideOutOfBoundaries
              display={(
                <Styles.ColorDisplayBorder
                  color={businessInfo?.chatConfiguration?.themeColor}
                  onClick={() => {
                    setIsColorPickerOpen(!isColorPickerOpen)
                  }}
                  selected={
                    !["#ff0000", "#ff9900", "#0014ff", "#412daf", "#1b6d3c"].includes(businessInfo?.chatConfiguration?.themeColor)
                  }
                >
                  <Styles.ColorDisplay
                    color={businessInfo?.chatConfiguration?.themeColor}
                    image="/color_wheel.png"
                  >
                  </Styles.ColorDisplay>
                </Styles.ColorDisplayBorder>

              )}
              onClickOutside={() => {
                setIsColorPickerOpen(false)
              }}
            >
              <ChromePicker
                color={businessInfo?.chatConfiguration?.themeColor}
                onChangeComplete={(color) => {
                  const clone = _.cloneDeep(businessInfo)
                  clone.chatConfiguration.themeColor = `${color.hex}${decimalToHex(color.rgb.a)}` 
                  setBusinessInfo(clone)
                }}
              />
            </Styles.StyledPopperContainer>
          </Styles.ColorPicker>
        </Box>
        <Box>
          <Styles.Label>
            <div className="title">Custom CSS</div>
          </Styles.Label>
          <Box>
            <CodeEditor
              id="code-editor-head"
              mode="jsx"
              height={364}
              className="code-editor"
              value={cssString}
              onChange={(value) => {
                const clone = _.cloneDeep(businessInfo)
                clone.chatConfiguration.customCss = value
                console.log("clone", clone)
                setCssString(value)
                setBusinessInfo(clone)
              }}
            />
          </Box>
        </Box>
      </Box>
      <Box pt={2} sx={{ width: "440px", minWidth: "440px", minHeight: "608px", boxSizing: "border-box" }}>
        <WebchatPreview 
          info={businessInfo} 
          cssString={cssString}
        />
      </Box>
    </Flex>
  )
}

export default Preferences
